import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Box, Card, CardContent, TextField, Button, Typography, Alert } from "@mui/material";
import MemoryIcon from "@mui/icons-material/Memory";

import api from "./../api";
import { MONO, tokens } from "./../theme";

export default function Login({ onIn }) {
  const navigate = useNavigate();
  const [username, setUsername] = useState("admin");
  const [password, setPassword] = useState("");
  const [err, setErr] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e?.preventDefault();
    setErr("");
    setBusy(true);
    try {
      await api.post("/api/login", { username, password }, { silent: true });
      onIn();
      navigate("/gpus", { replace: true });
    } catch {
      setErr("That username and password didn't match. Try again.");
    } finally {
      setBusy(false);
    }
  };

  return (
    <Box
      sx={{
        minHeight: "100vh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        p: 2,
        // faint instrument grid backdrop
        background: `radial-gradient(1100px 600px at 50% -10%, rgba(46,139,230,.10), transparent 60%),
          linear-gradient(${tokens.line} 1px, transparent 1px) 0 0 / 100% 34px,
          ${tokens.mist}`,
      }}
    >
      <Card sx={{ width: 380, maxWidth: "94vw", boxShadow: "0 18px 50px rgba(14,27,46,.12)" }}>
        <CardContent sx={{ p: 4 }}>
          <Box sx={{ display: "flex", alignItems: "center", gap: 1.25, mb: 0.5 }}>
            <Box
              sx={{
                width: 34,
                height: 34,
                borderRadius: "9px",
                background: tokens.vramGradient,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                boxShadow: "0 2px 12px rgba(46,139,230,.4)",
              }}
            >
              <MemoryIcon sx={{ color: "#fff", fontSize: 20 }} />
            </Box>
            <Box>
              <Typography sx={{ fontWeight: 700, fontSize: "1.05rem", lineHeight: 1.1 }}>Generator</Typography>
              <Typography sx={{ fontFamily: MONO, fontSize: ".6rem", letterSpacing: ".18em", textTransform: "uppercase", color: tokens.slate }}>
                Console
              </Typography>
            </Box>
          </Box>

          <Typography variant="body2" color="text.secondary" sx={{ mb: 2.5, mt: 1.5 }}>
            Sign in to manage GPUs, generators, and access tokens.
          </Typography>

          <Box component="form" onSubmit={submit}>
            <TextField
              fullWidth
              size="small"
              label="Username"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              autoFocus
              sx={{ mb: 1.5 }}
            />
            <TextField
              fullWidth
              size="small"
              type="password"
              label="Password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              sx={{ mb: err ? 1.5 : 2 }}
            />
            {err && (
              <Alert severity="error" sx={{ mb: 2, py: 0.25 }}>
                {err}
              </Alert>
            )}
            <Button type="submit" variant="contained" fullWidth size="large" disabled={busy || !password}>
              {busy ? "Signing in…" : "Sign in"}
            </Button>
          </Box>
        </CardContent>
      </Card>
    </Box>
  );
}
